import React from "react";
import styles from "./BetTableDragonLion.module.css";

export default function BetTableDragonLion({ data = [], exposures = {} }) {
  const columns = ["Dragon", "Tiger", "Lion"];
  const cards = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];

  const leftCards = cards.slice(0, 4);  // A,2,3,4
  const rightCards = cards.slice(4);    // 5 to K

  // Helper function to get card image path from dtlimg folder
  const getCardImagePath = (card) => {
    const cardMap = {
      'A': '1',
      '2': '2',
      '3': '3',
      '4': '4',
      '5': '5',
      '6': '6',
      '7': '7',
      '8': '8',
      '9': '9',
      '10': '10',
      'J': '11',
      'Q': '12',
      'K': '13'
    };
    const cardNumber = cardMap[card] || card;
    return `/assets/img/dtlimg/${cardNumber}.jpg`;
  };

  // Helper function to find bet data
  const findBetData = (label, col) => {
    return data.find(
      (item) =>
        item.nat.toLowerCase().includes(label.toLowerCase()) &&
        item.nat.toLowerCase().includes(col.toLowerCase())
    );
  };

  // Check if bet is suspended
  const isSuspended = (betData) => {
    return betData?.gstatus?.toUpperCase() === "SUSPENDED" || !betData || betData.b === 0 || betData.b === null || betData.b === undefined;
  };

  // Get exposure value for a bet
  const getExposure = (betName) => {
    if (!exposures || Object.keys(exposures).length === 0) {
      return 0;
    }

    const exposureKeys = [
      betName,
      betName?.toLowerCase(),
      betName?.trim(),
      betName?.toLowerCase().trim(),
    ];

    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined && exposures[key] !== null) {
        const expValue = parseFloat(exposures[key]);
        if (!isNaN(expValue)) {
          return expValue;
        }
      }
    }
    return 0;
  };

  // Format exposure value
  const formatExposure = (value) => {
    if (!value || value === 0) return "0";
    return value < 0 ? value.toFixed(0) : `+${value.toFixed(0)}`;
  };

  const renderCard = (card) => (
    <div className={styles.card}>
      <img 
        src={getCardImagePath(card)} 
        alt={card}
        className={styles.cardImage}
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
    </div>
  );

  // Render special bets rows (only for left table)
  const renderSpecialBets = () => (
    ["Winner", "Black", "Red", "Odd", "Even"].map((label, index) => (
      <tr key={`special-${index}`} className={styles.tableRow}>
        <td className={styles.betType}>{label}</td>
        {columns.map((col) => {
          const bet = findBetData(label, col);
          const suspended = isSuspended(bet);
          const exposureKey = `${col} ${label}`;
          const exposure = getExposure(exposureKey);

          return (
            <td
              key={`${col}-${label}`}
              className={`${styles.oddsCell} ${suspended ? styles.suspended : ""}`}
            >
              <span style={{ color: 'white' }}>{formatExposure(exposure)}</span>
            </td>
          );
        })}
      </tr>
    ))
  );

  // Render rows for cards
  const renderCardRows = (cardsToRender) =>
    cardsToRender.map((card) => (
      <tr key={card} className={styles.tableRow}>
        <td className={styles.cardCell}>{renderCard(card)}</td>
        {columns.map((col) => {
          const label = `${col} ${card}`;
          const bet = data.find(
            (item) => item.nat.toLowerCase() === label.toLowerCase()
          );
          const suspended = isSuspended(bet);
          const exposure = getExposure(label);

          return (
            <td
              key={`${col}-${card}`}
              className={`${styles.oddsCell} ${suspended ? styles.suspended : ""}`}
            >
              <span style={{ color: 'white' }}>{formatExposure(exposure)}</span>
            </td>
          );
        })}
      </tr>
    ));

  return (
    <div className={styles.dragonLionTable}>
      <div className={styles.tableGrid}>
        {/* Left Table: special bets + cards A to 4 */}
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableHeaderRow}>
              <th className={styles.emptyHeader}></th>
              {columns.map((col, index) => (
                <th key={index} className={styles.columnHeader}>
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {renderSpecialBets()}
            {renderCardRows(leftCards)}
          </tbody>
        </table>

        {/* Right Table: cards 5 to K (no special bets) */}
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableHeaderRow}>
              <th className={styles.emptyHeader}></th>
              {columns.map((col, index) => (
                <th key={index} className={styles.columnHeader}>
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {renderCardRows(rightCards)}
          </tbody>
        </table>
      </div>
    </div>
  );
}

